

















// @ is an alias to /src
import { getDefaultAloBaseLg } from '@/models/alo/AloBaseLg'
import { AloPlat } from '@/models/alo/AloPlat'
import { ItemPanier } from '@/models/alo/ItemPanier'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import BasePlat from '@/components/carte/BasePlat'
import { VuetifyConfirmObject } from 'vuetify-confirm'

@Component({
  name: 'ProduitQuantfiable',  
  props: {
    reset:{
      type:Boolean,
      default:false
    },
    allowAdd:{
      type:Boolean,
      default:true
    },
    dense:{
      type:Boolean,
      default:false
    }
  }
})
export default class ProduitQuantfiable extends mixins(BasePlat) {
  itemPanier:ItemPanier = new ItemPanier()
  reset!:boolean
  allowAdd!:boolean
  dense!:boolean

  @Watch("plat")
  onPlatChange(){
    this.resetItemPanier()
  }

  @Watch("reset")
  onReset(){
    if(this.reset) this.resetItemPanier()
  }

  mounted(){
    this.resetItemPanier() 
  }

  resetItemPanier(){
    this.itemPanier = new ItemPanier({plat:this.plat,cuisson:{lgs:[]},parfum:{lgs:[]},qty:this.allowAdd?1:0,parentId:this.platParentId,sectionId:this.platSectionId,arboId:this.platArboId})
  }

  get showAllergene(){
    return this.$store.myGetters.showAllergene
  }

  addItemToPanier() {       
    if(!this.canAdd)  this.$confirm(this.$t('Cart.AlertProductMix').toString(),{title: this.$t('Cart.AlertProductMixTitle'),buttonTrueText:this.$t('Global.Ok'),buttonFalseText:""} as VuetifyConfirmObject)
    else
    {     
      this.addToCart(this.itemPanier)
      this.resetItemPanier()
    }
  }
}
